import { EventSentToMobileApp } from "../../constants/GlobalTypesAndEnumsAndConstants";
import { getNativeStartupProfileRequest } from "../../utils/startup-profile";

// Several mounted components report readiness; enrich all of them at the wire
// boundary so a child effect cannot retire native profiling before its parent.
export function serializeMobileAppEvent(typeEvent: EventSentToMobileApp, message?: string): string {
  return JSON.stringify({
    typeEvent,
    message: message || (typeEvent === EventSentToMobileApp.LOADED_PAGE
      ? getNativeStartupProfileRequest()
      : null) || null,
  });
}
